export const SCROLL_TARGET_KIND = {
  Message: "message",
  Version: "version",
} as const;

export type ScrollTargetKind =
  typeof SCROLL_TARGET_KIND[keyof typeof SCROLL_TARGET_KIND];

export const DEFAULT_SCROLL_OFFSET_TOP = 80;
// Newest-message anchor: how far below the viewport top to place the last message's
// top when scrolling to latest. Kept >= the chat's top scroll fade (40px) so the
// anchored message never renders under the fade gradient.
export const LATEST_MESSAGE_ANCHOR_OFFSET_TOP = 40;
export const NEAR_BOTTOM_THRESHOLD_PX = 140;
export const SCROLL_DURATION_MS = 650;
export const SPRING_START = 0.82;
export const SPRING_OSCILLATIONS = 2.2;
export const SPRING_DAMPING = 6;
export const SPRING_MAX_PX = 24;
export const SPRING_MAX_RATIO = 0.04;
